module.exports = __webpack_public_path__ + "img/pic_format_mov@2x.69607368.jpeg";